import type { MfaState } from './types';

const initialState: MfaState = {
  authToken: null,
  authTokenExpiration: null,
  captchaType: null,
  funnelSessionId: null,
  isGuestAuth: false,
  isOutage: false,
  isReauthing: false,
  guestAuthToken: null,
  loginError: null,
  loginType: null,
  magicLinkType: null,
  onboardingToken: null,
  onboardingUserId: null,
  refreshToken: null,
  smsCaptchaToken: null,
  appealToken: null,
  captchaKey: null,
  selfieChallengeToken: null,
  selfieStatus: null,
};

export default initialState;
